module.exports = __webpack_public_path__ + "img/logo-mobile.6ea07d5b.png";